import { render, staticRenderFns } from "./bannerImg.vue?vue&type=template&id=24c56208&scoped=true"
import script from "./bannerImg.vue?vue&type=script&lang=js"
export * from "./bannerImg.vue?vue&type=script&lang=js"
import style0 from "./bannerImg.vue?vue&type=style&index=0&id=24c56208&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c56208",
  null
  
)

export default component.exports